<template>
  <div class="sidebar">
    <div class="sidebar-wrap">
      <div class="searchbox">
        <div class="title">{{$t('btn.search')}}</div>
        <Input class="search" v-model="searchVal" icon="ios-search-strong" type="text" :placeholder="$t('newsActivity.searchPlaceholder')" style="width:100%" @on-enter="search" @on-click="search"/>
      </div>
      <div class="classify" v-if="!_.isEmpty(categoryList)">
        <div class="title">{{$t('newsActivity.classify')}}</div>
        <ul>
          <li v-for="(item, idx) in categoryList" :key="`cate-${idx}`" :class="{active: currentCategory === item.id}">
            <a href="#" @click.stop.prevent="catetorySearch($event, item.id)">{{item.name}}</a>
          </li>
        </ul>
      </div>
      <!-- <div class="daterange">
        <div class="title">{{$t('common.date')}}</div>
        <DatePicker class="dateselect" v-model="dateVal" type="daterange" placement="bottom-start" split-panels clearable :editable="false" :placeholder="$t('newsActivity.datePlaceholder')" style="width:100%" @on-change="dateSearch" format="MM/dd/yyyy"></DatePicker>
        <ul>
          <li v-for="(item, idx) in dateList" :key="`date-${idx}`" :class="{active: currentDate === item.id}">
            <a href="#" @click.stop.prevent="dateQuickSearch($event, item.id)">{{item.name}}</a>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapDataState } = createNamespacedHelpers('data')

export default {
  name: 'FaqListSider',
  props: ['keyword', 'categoryID', 'timeStr', 'cid'],
  data () {
    return {
      searchVal: '',
      dateVal: '',
      currentCategory: -1,
      currentDate: -1,
      dateList: [
        // {id: -1, name: this.$t('common.allDate')},
        {id: 1, name: this.$t('common.today')},
        {id: 2, name: this.$t('common.yesterday')},
        {id: 3, name: this.$t('common.lastWeek')},
        {id: 4, name: this.$t('common.laseMonth')}
      ]
    }
  },
  computed: {
    ...mapDataState({
      categoryList (state) {
        let res = [{id: -1, name: this.$t('common.allCate')}]
        res.push(...this._.filter(state.categoryAll, (v) => v.type === 3))
        return res
      }
    })
  },
  watch: {
    cid (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.currentCategory = parseInt(newVal) || -1
        this.$emit('update:categoryID', this.currentCategory)
      }
    }
  },
  methods: {
    search () {
      this.$emit('update:keyword', this._.trim(this.searchVal))
    },
    catetorySearch (event, cid) {
      this.currentCategory = parseInt(cid)
      this.$emit('update:categoryID', parseInt(this._.trim(cid)) || -1)
    },
    dateQuickSearch (event, did) {
      this.currentDate = parseInt(did)
      let startTimestamp = ''
      let endTimestamp = ''
      let d = new Date()
      switch (this.currentDate) {
        case 1:
          startTimestamp = this.getDateRangeStartStr(d)
          endTimestamp = this.getDateRangeEndStr(d)
          break
        case 2:
          d.setDate(d.getDate() - 1)
          startTimestamp = this.getDateRangeStartStr(d)
          endTimestamp = this.getDateRangeEndStr(d)
          break
        case 3:
          // let num = d.getDay() - 1
          let num = d.getDay()
          // d.setDate(d.getDate() - num)
          d.setDate(d.getDate() - num - 7)
          startTimestamp = this.getDateRangeStartStr(d)
          d.setDate(d.getDate() + 6)
          endTimestamp = this.getDateRangeEndStr(d)
          break
        case 4:
          d.setMonth(d.getMonth() - 1)
          d.setDate(1)
          startTimestamp = this.getDateRangeStartStr(d)
          d.setMonth(d.getMonth() + 1)
          d.setDate(d.getDate() - 1)
          endTimestamp = this.getDateRangeEndStr(d)
          break
      }
      this.dateVal = [new Date(startTimestamp), new Date(endTimestamp)]
      this.$emit('update:timeStr', `${startTimestamp}|${endTimestamp}`)
    },
    getDateRangeStartStr (d) {
      d.setHours(0)
      d.setMinutes(0)
      d.setSeconds(0)
      return d.getTime()
    },
    getDateRangeEndStr (d) {
      d.setHours(23)
      d.setMinutes(59)
      d.setSeconds(59)
      return d.getTime()
    },
    dateSearch (dateArr, dateType) {
      this.currentDate = -1
      if (!this._.isEmpty(dateArr) && dateType === 'date') {
        let startTimestamp = (new Date(`${dateArr[0]} 00:00:00`)).getTime()
        let endTimestamp = (new Date(`${dateArr[1]} 23:59:59`)).getTime()
        this.$emit('update:timeStr', `${startTimestamp}|${endTimestamp}`)
      } else {
        this.$emit('update:timeStr', '')
      }
    }
  }
}
</script>
<style scoped>
  .sidebar-wrap{
    padding-bottom: 20px;
  }
  .title{
    font-size: 1.3rem;
    color: #333;
    font-weight: bold;
    background: url("~@/assets/images/icons/show/guide.png") 0 1px no-repeat transparent;
    background-size: 4px 12px;
    padding-left: 13px;
    margin-bottom: 15px;
    position: relative;
    top: 1px;
  }
  .searchbox >>> .ivu-input,
  .daterange >>> .ivu-input{
    border-color: #D0D0D0;
    border-radius: 3px;
    padding-left: 12px;
    font-size: 14px;
  }
  .searchbox >>> .ivu-input:focus,
  .daterange >>> .ivu-input:focus{
    border-color: #1F8AFD;
  }
  .searchbox >>> .ivu-input::-webkit-input-placeholder,
  .daterange >>> .ivu-input::-webkit-input-placeholder{
    font-size: 12px;
  }
  .searchbox >>> .ivu-input:-moz-placeholder,
  .daterange >>> .ivu-input:-moz-placeholder{
    font-size: 12px;
  }
  .searchbox >>> .ivu-input::-moz-placeholder,
  .daterange >>> .ivu-input::-moz-placeholder{
    font-size: 12px;
  }
  .searchbox >>> .ivu-input:-ms-input-placeholder,
  .daterange >>> .ivu-input:-ms-input-placeholder{
    font-size: 12px;
  }
  .search >>> .ivu-icon,
  .daterange >>> .ivu-icon-ios-close{
    cursor: pointer;
  }
  .search >>> .ivu-icon-ios-search-strong{
    background: url("~@/assets/images/icons/news/search.png") center center no-repeat transparent;
    background-size: 13px;
  }
  .daterange >>> .ivu-icon-ios-calendar-outline{
    background: url("~@/assets/images/icons/news/cal.png") center center no-repeat transparent;
    background-size: 12px;
  }
  .search >>> .ivu-icon-ios-search-strong:before,
  .daterange >>> .ivu-icon-ios-calendar-outline:before{
    content: none;
  }
  .daterange >>> .ivu-select-dropdown{
    font-size: 13px;
  }
  .daterange >>> .ivu-select-dropdown .ivu-date-picker-cells-header span{
    font-size: 13px;
  }
  .classify{
    margin: 30px 0 20px;
    padding-bottom: 20px;
    border-bottom: 0.5px solid #E9E9E9;
  }
  ul{
    margin-top: 15px;
    margin-left: 10px;
  }
  ul li{
    margin-bottom: 10px;
    padding-left: 12px;
  }
  ul li:last-child{
    margin-bottom: 0;
  }
  ul li a{
    color: #999;
    font-size: 1.3rem;
  }
  ul li a:hover{
    color: #1F8AFD;
  }
  ul li.active a:after{
    width: 0;
    height: 0;
  }
  ul li.active a{
    color: #1F8AFD;
  }
  ul li.active{
    background: url("~@/assets/images/icons/news/arrow.png") 0 center no-repeat transparent;
    background-size: 7px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/faq/ListSider.vue